<app-header></app-header>
<main class="page-content">
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
